const products = [
  {
    id: "vpn",
    name: "BADI VPN",
    tagline: "Privacy Without Compromise",
    description:
      "A next-generation VPN for iOS that encrypts your internet traffic, shields your identity, and ensures your digital freedom — all without sacrificing speed or battery life.",
    highlights: [
      "Military-grade AES-256 encryption",
      "Zero-log privacy policy",
      "Global server network",
      "One-tap connection",
      "Battery-optimized protocols",
    ],
    icon: "ri-shield-keyhole-line",
    accentColor: "#00d4ff",
    image:
      "https://public.readdy.ai/ai/img_res/4882644978de5c64b3855afbe15877d6.jpg",
  },
  {
    id: "cleaner",
    name: "BADI Cleaner",
    tagline: "Speed. Storage. Simplicity.",
    description:
      "An intelligent iOS cleaner that removes junk files, duplicate photos, and unnecessary caches to free up storage space and restore your device to peak performance.",
    highlights: [
      "Smart duplicate detection",
      "One-tap deep clean",
      "Large file scanner",
      "Contact merge tool",
      "Real-time storage insights",
    ],
    icon: "ri-delete-bin-6-line",
    accentColor: "#00ffaa",
    image:
      "https://readdy.ai/api/search-image?query=iPhone%20displaying%20a%20device%20cleaner%20app%20with%20circular%20storage%20progress%20indicator%2C%20minimalist%20dark%20UI%20design%2C%20green%20accent%20colors%2C%20clean%20modern%20app%20interface%20showing%20storage%20stats%20and%20optimization%20results&width=600&height=700&seq=cleaner-product-01&orientation=portrait",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="bg-[#111111] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase text-[#00d4ff] mb-4">
            Our Products
          </span>
          <h2 className="text-5xl font-bold text-white leading-tight">
            Crafted for iOS Excellence
          </h2>
          <p className="text-[#7a7a7a] text-lg mt-4 max-w-xl mx-auto">
            Two powerful applications designed to protect your privacy and keep your
            device running at its best.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-[#1a1a1a] border border-[#272727] rounded-2xl overflow-hidden flex flex-col transition-transform duration-300 hover:-translate-y-1"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent"></div>
                <div
                  className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full border"
                  style={{ borderColor: product.accentColor, color: product.accentColor }}
                >
                  <i className={`${product.icon} text-xl`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-1">
                <span
                  className="text-xs font-semibold tracking-[0.2em] uppercase mb-2"
                  style={{ color: product.accentColor }}
                >
                  {product.tagline}
                </span>
                <h3 className="text-3xl font-bold text-white mb-3">{product.name}</h3>
                <p className="text-[#8a8a8a] text-base leading-relaxed mb-6">
                  {product.description}
                </p>

                <ul className="flex flex-col gap-2 mt-auto">
                  {product.highlights.map((item) => (
                    <li key={item} className="flex items-center gap-3 text-sm text-[#aaa]">
                      <span
                        className="w-4 h-4 flex items-center justify-center flex-shrink-0"
                        style={{ color: product.accentColor }}
                      >
                        <i className="ri-check-line text-base"></i>
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
